import { ACTIVE_VALUE, ALL_VALUE } from './helper';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { systemAlertStatusCodes } from '../screening/alert-status/alertStatusesConstants';
import { InternalApiScreeningAlertStatus } from '../api-internal';

const statusActive: DropdownOption = {
  key: 'ACTIVE',
  value: ACTIVE_VALUE,
  label: 'Active statuses',
};
const statusAll: DropdownOption = {
  key: 'ALL',
  value: ALL_VALUE,
  label: 'All statuses',
};
export const statusDefault: DropdownOption = {
  key: systemAlertStatusCodes.new,
  value: systemAlertStatusCodes.new,
  label: 'New',
};
export const ALERT_STATUS_PARAM = 'status';

export const getFilterAlertStatuses = (activeStatuses: InternalApiScreeningAlertStatus[]): DropdownOption[] => {
  const uniqueStatuses = Array.from(
    new Set(activeStatuses.filter((status) => status.enabledMonitoring).map((status) => status.code))
  );
  return [statusActive, statusAll].concat(
    uniqueStatuses.map((status) => {
      return {
        key: status,
        value: status,
        label: status,
      };
    })
  );
};

/*
  Returns status that is in effect. Taking into consideration user selection and query parameters.
  <ul>
    <li>If status is selected by the user, return that one.</li>
    <li>If not, then return one from query parameters.</li>
    <li>If that's not possible, then return default status.</li>
  </ul>
 */
export const statusSelectedOrURLOrDefault = (
  selectedStatus: DropdownOption | undefined,
  statuses: InternalApiScreeningAlertStatus[]
): DropdownOption => {
  if (selectedStatus !== undefined) {
    return selectedStatus;
  }

  const params = new URLSearchParams(location.search);
  const value = params.get(ALERT_STATUS_PARAM);
  if (value !== null) {
    const existingStatus = getFilterAlertStatuses(statuses).find((k) => k.value === value);
    if (existingStatus !== undefined) {
      return existingStatus;
    }
  }

  return statusDefault;
};

export const apiStatusesToFetch = (
  status: DropdownOption,
  activeStatuses: InternalApiScreeningAlertStatus[]
): string[] | undefined => {
  if (status.value === ALL_VALUE) {
    return undefined;
  } else if (status.value === ACTIVE_VALUE) {
    return activeStatuses.filter((status) => status.enabledMonitoring && !status.isFinal).map((status) => status.code);
  } else {
    return [status.value];
  }
};

export const apiStatusesToFetchForTransactionBacklog = (
  selectedStatus: DropdownOption | undefined,
  activeStatuses: InternalApiScreeningAlertStatus[]
) => {
  const status = statusSelectedOrURLOrDefault(selectedStatus, activeStatuses);
  return apiStatusesToFetch(status, activeStatuses);
};
